import { Checkbox, cn, Dialog, Label } from "@win-reality/react-ui";
import { useEffect, useState } from "react";

type DeactivateUmpireDialogProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm?: () => void;
  isSubmitting?: boolean;
};

function DeactivateUmpireDialog({
  isOpen,
  onOpenChange,
  onConfirm,
  isSubmitting,
}: DeactivateUmpireDialogProps) {
  const [confirmChecked, setConfirmChecked] = useState(false);

  useEffect(() => {
    if (!isOpen) setConfirmChecked(false);
  }, [isOpen]);

  return (
    <Dialog
      open={isOpen}
      onOpenChange={onOpenChange}
      size="md"
      hideXButton
      title="Deactivate Automatic Umpire?"
      description="Live cameras and Stat Tracking & ABS Challenge System will remain active. If ABS was included in a paid SmartPark session, deactivating it may impact the purchased experience."
      primaryAction={{
        label: "Continue",
        variant: "destructive",
        isDisabled: !confirmChecked || !!isSubmitting,
        isLoading: !!isSubmitting,
        onClick: () => {
          if (confirmChecked) onConfirm?.();
        },
      }}
    >
      <div
        className={cn(
          "flex items-center gap-2 w-full border border-gray-200 rounded-md p-5",
          confirmChecked && "bg-gray-100",
        )}
      >
        <Checkbox
          id="confirm-deactivation"
          checked={confirmChecked}
          onCheckedChange={(checked) => setConfirmChecked(checked)}
        />

        <Label
          htmlFor="confirm-deactivation"
          className={cn(
            "font-regular cursor-pointer leading-none mb-0 flex items-center w-full",
          )}
        >
          <div className="flex justify-between items-center w-full">
            <div>Turn off Automatic Umpire</div>

            <div className="uppercase text-xs text-destructive">required</div>
          </div>
        </Label>
      </div>
    </Dialog>
  );
}

export { DeactivateUmpireDialog };
